/**
 * Google OAuth (GIS) côté front — activé uniquement si `VITE_GOOGLE_OAUTH_CLIENT_ID`
 * est défini et non vide (après trim).
 */
const readRaw = (): string =>
  String(import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID ?? "").trim();

export const GOOGLE_OAUTH_CLIENT_ID: string | null = readRaw() || null;

export const isGoogleOAuthEnabled = (): boolean =>
  GOOGLE_OAUTH_CLIENT_ID !== null;
